export default "__VITE_ASSET__YVzlTVfj__"